import {
  DELETE_LOCATIONS_CATALOG,
  DELETE_LOCATIONS_CATALOG_SUCCESS,
  DELETE_LOCATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteLocationsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_LOCATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LOCATIONS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_LOCATIONS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
